import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";


function Rightlist(){

    let rStore = useSelector((state)=>{return state})
    let navigate = useNavigate()
    let getLogin = sessionStorage.getItem('login')
    let writed = localStorage.getItem('writed')
    let Lpost = JSON.parse(writed) 

    if (getLogin){
        return(
        <div style={{textAlign:'center'}}>
        최신 글 리스트
        <br></br>
        <br></br>
        {Lpost.map(function(a,i){
            return(
                <div
                style={{fontSize:14}} 
                onClick={()=>{
                    navigate('/detail/'+i)
                }}
                >{Lpost[i][1]}</div>
            )
        })}
        <br></br>
    </div>
    )
    } 
    
    else {
    return(
        <div style={{textAlign:'center'}}>
            최신 글 리스트
            <br></br>
            <br></br>
            {rStore.postSub.map(function(a,i){
                return(
                    <div
                    style={{fontSize:14}} 
                    onClick={()=>{
                        navigate('/detail/'+i)
                    }}
                    >{rStore.postSub[i]}</div>
                )
            })}
            <br></br>
        </div>
    )
    }
}

export default Rightlist